import { ClientSideStorageType } from '../../react/models/client-side-storage-type.enum';
import { ClientSideStorageService } from '../../react/services/client-side-storage.service';
import './_cookie-selector-block.scss';

(function cookieSelector() {
  if (document.getElementsByClassName('cookie-selector-block').length > 0) {
    class CookieSelectorBlock {
      public init() {
        const button = document.getElementById('save-cookie-choices') as HTMLButtonElement;
        const message = document.getElementById('cookie-selection-saved-message') as HTMLElement;
        const errorMessage = document.getElementById('cookie-selection-error-message') as HTMLElement;

        this.setCookieSelectionSelected('functional-cookies', ClientSideStorageService.isConsentGiven(ClientSideStorageType.Functional));

        button.addEventListener('click', () => {
          try {
            let status = ClientSideStorageType.Necessary;
            if (this.getCookieSelectionSelected('functional-cookies'))
               
              status |= ClientSideStorageType.Functional;

            // NV-4847 Analytics cookies will, for now, be classified as necessary. Keep if this changes in the future.
            // if (this.getCookieSelectionSelected('analytics-cookies'))
            //   // eslint-disable-next-line no-bitwise
            //   status |= ClientSideStorageType.Analytics;

             
            const success = ClientSideStorageService.setConsentStatus(status);

            if (success) message.classList.remove('d-none');
            else errorMessage.classList.remove('d-none');
          } catch {
            message.classList.add('d-none');
            errorMessage.classList.remove('d-none');
          }
        });

        const radios = document.querySelectorAll('.cookie-selector-block input[type=radio]');
        radios.forEach((radio) =>
          radio.addEventListener('change', () => {
            message.classList.add('d-none');
            errorMessage.classList.add('d-none');
          })
        );
      }

      private getCookieSelectionSelected(name: string): boolean {
        const cookie = document.querySelector(`input[name="${name}"]:checked`) as HTMLInputElement;
        return cookie.value === 'on';
      }

      private setCookieSelectionSelected(name: string, isOn: boolean): void {
        const cookie = document.querySelector(`input[name="${name}"][value=${isOn ? 'on' : 'off'}]`) as HTMLInputElement;
        cookie.setAttribute('checked', 'checked');
      }
    }
    const block = new CookieSelectorBlock();
    block.init();
  }
})();
